import { useEffect, useState } from 'react';
type Notice = { message: string; linkUrl: string; linkLabel: string; endsAt: string | null };
export function Announcement() {
  const [notice, setNotice] = useState<Notice | null>(null);
  useEffect(() => {
    let active = true;
    let sequence = 0;
    const refresh = async () => {
      const current = ++sequence;
      try {
        const response = await fetch('/api/announcement', { cache: 'no-store' });
        if (!response.ok) return;
        const data = (await response.json()) as { announcement: Notice | null };
        if (active && current === sequence) setNotice(data.announcement);
      } catch {
        /* Leave the page usable when the notice cannot refresh. */
      }
    };
    void refresh();
    const interval = window.setInterval(() => void refresh(), 15000);
    const focus = () => void refresh();
    window.addEventListener('focus', focus);
    return () => {
      active = false;
      clearInterval(interval);
      window.removeEventListener('focus', focus);
    };
  }, []);
  useEffect(() => {
    if (!notice?.endsAt) return;
    let timer = 0;
    const expire = () => {
      const delay = Date.parse(notice.endsAt!) - Date.now();
      if (delay <= 0) setNotice(null);
      else timer = window.setTimeout(expire, Math.min(delay, 2147483647));
    };
    expire();
    return () => clearTimeout(timer);
  }, [notice]);
  if (!notice) return null;
  return (
    <aside className="announcement-bar" aria-label="Community announcement">
      <span>{notice.message}</span>
      {notice.linkUrl && (
        <a href={notice.linkUrl} rel="noreferrer">
          {notice.linkLabel}
        </a>
      )}
    </aside>
  );
}
